import { useSyncExternalStore } from 'react';

const listeners = new Set();
let style;
const snapshot = () => !document.hidden;
function changed() {
  document.documentElement.classList.toggle('pipeline-hidden', document.hidden);
  listeners.forEach(listener => listener());
}
function subscribe(listener) {
  if (!listeners.size) {
    style = document.createElement('style');
    // Decorative CSS effects only. Socket reduction and recovery stay active.
    style.textContent = '.pipeline-hidden .sales-pipeline-type *, .pipeline-hidden .cpt * { animation: none !important; transition: none !important; }';
    document.head.appendChild(style);
    document.addEventListener('visibilitychange', changed);
    changed();
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (!listeners.size) {
      document.removeEventListener('visibilitychange', changed);
      document.documentElement.classList.remove('pipeline-hidden');
      style?.remove(); style = null;
    }
  };
}
export const usePageVisible = () => useSyncExternalStore(subscribe, snapshot, () => true);
